import { navigate } from 'gatsby';
import redirectToExternalPage from './RedirectToExternalPage';

const isInternal = uri => {
  const isLocalDomain = new RegExp('^(https?://)?([a-z]+-)?miwom.wom.cl(/.+)?');
  if (/^\//.test(uri)) return uri;
  const match = uri.match(isLocalDomain);
  return match ? match[3] : '';
};

const redirectInternalOrExternal = href => {
  const path = isInternal(href);
  return path ? navigate(path) : redirectToExternalPage(href, true);
};

const redirectToWompay = (pathWompay = 'payment-methods') => {
  const currentDomain = window.location.origin;
  redirectToExternalPage(
    `${process.env.WOMPAY_URL}/${pathWompay}?ref=${currentDomain}/home`
  );
};

const redirectToPDP = (sku = '', name = '', typePrice = '2') => {
  return navigate(`/catalogo/${sku}/${name?.split(' ').join('-')}`, {
    state: {
      typePrice,
    },
  });
};

export {
  isInternal,
  redirectInternalOrExternal,
  redirectToWompay,
  redirectToPDP,
};
export default {
  isInternal,
  redirectInternalOrExternal,
  redirectToWompay,
  redirectToPDP,
};
